var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8125 2.25C7.41016 2.25 7.9375 2.77734 7.9375 3.375V5.0625C7.9375 6.64453 9.16797 7.875 10.75 7.875C12.2969 7.875 13.5625 6.64453 13.5625 5.0625V3.375C13.5625 2.77734 14.0547 2.25 14.6875 2.25C15.2852 2.25 15.8125 2.77734 15.8125 3.375V4.5C15.8125 5.69531 15.8828 6.67969 16.0234 7.52344L4 16.1016V12.1992C4 11.6016 4.21094 11.0039 4.49219 10.5117C4.98438 9.5625 5.6875 7.69922 5.6875 4.5V3.375C5.6875 2.77734 6.17969 2.25 6.8125 2.25ZM4.10547 18.7734L16.6562 9.80859C16.7617 10.0898 16.8672 10.3008 16.9727 10.4766C17.2539 11.0039 17.5 11.6016 17.5 12.1992V18C17.5 19.2656 16.4805 20.25 15.25 20.25H6.25C5.26562 20.25 4.42188 19.6523 4.10547 18.7734Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default ForwardRef;